module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#thump",
      toString: function () {
        return this.url;
      }
    }